
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDockRightGoogle as ObiDockRightGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-dock-right-google.js';
 
 
 

 
 export const ObiDockRightGoogle = createComponent({
   react: React,
   tagName: 'obi-dock-right-google',
   elementClass: ObiDockRightGoogleElement,
   events: {
     
   }
  });
 
 